import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export type PageContainerVariant = 'wide' | 'narrow' | 'default';

interface PageContainerProps {
  variant?: PageContainerVariant;
  className?: string;
  children: ReactNode;
}

const VARIANT_CLASSES: Record<PageContainerVariant, string> = {
  wide: 'mx-auto w-full max-w-none',
  narrow: 'mx-auto w-full max-w-5xl',
  default: 'mx-auto w-full max-w-7xl',
};

export function PageContainer({
  variant = 'default',
  className,
  children,
}: Readonly<PageContainerProps>) {
  return <div className={cn(VARIANT_CLASSES[variant], className)}>{children}</div>;
}
